(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pm-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-video-stories')) {
    customElements.define('pm-video-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.items = this.cards.map(card => ({ card, video:card.querySelector('video'), ratio:0, paused:false, attempted:false, fade:0 })).filter(item => item.video);
        this.audio = null;
        this.frame = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.saveData = navigator.connection?.saveData === true;
        const opts = { signal:this.abort.signal };
        this.querySelectorAll('[data-controls]').forEach(el => el.hidden = false);
        this.querySelector('[data-nav]').hidden = false;
        this.addEventListener('click', event => this.click(event), opts);
        this.track.addEventListener('scroll', () => this.queue(), { ...opts, passive:true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowRight','ArrowLeft'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, opts);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopAll();
          else this.queue();
        }, opts);
        window.addEventListener('pagehide', () => this.stopAll(), opts);
        window.addEventListener('pageshow', () => this.queue(), opts);
        document.addEventListener('pmvs:sound', event => {
          if (event.detail !== this) this.mute(this.audio, true);
        }, opts);
        this.reduced.addEventListener('change', () => {
          this.stopAll();
          this.items.forEach(item => item.attempted = false);
          this.queue();
        }, opts);
        this.items.forEach(item => {
          item.video.muted = true;
          item.video.defaultMuted = true;
          item.video.addEventListener('playing', () => {
            item.card.setAttribute('data-ready','');
            this.sync(item);
          }, opts);
          ['pause','volumechange'].forEach(name => item.video.addEventListener(name, () => this.sync(item), opts));
          item.video.addEventListener('error', () => {
            this.mute(item, true);
            item.card.querySelector('[data-error]').hidden = false;
            item.card.removeAttribute('data-ready');
          }, opts);
        });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const item = this.items.find(candidate => candidate.card === entry.target);
            if (item) item.ratio = entry.intersectionRatio;
          });
          this.queue();
        }, { threshold:Array.from({length:41}, (_, i) => i / 40) });
        this.items.forEach(item => this.observer.observe(item.card));
        this.resize = new ResizeObserver(() => this.queue());
        this.resize.observe(this.track);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-card]');
          if (card) this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'});
        }, opts);
        this.queue();
      }
      disconnectedCallback() {
        this.stopAll();
        this.abort?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.abort = null;
      }
      queue() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }
      update() {
        const max = this.track.scrollWidth-this.track.clientWidth;
        this.querySelector('[data-nav]').hidden = max < 4;
        this.querySelector('[data-prev]').disabled = this.track.scrollLeft < 4;
        this.querySelector('[data-next]').disabled = this.track.scrollLeft >= max-4;
        if (document.hidden) return;
        this.items.forEach(item => {
          if (item.ratio <= .05) {
            if (!item.leaving && (!item.video.paused || !item.video.muted)) {
              item.leaving = true;
              this.mute(item, false, () => {
                item.leaving = false;
                if (item.ratio <= .05) {
                  item.video.pause();
                  item.attempted = false;
                }
              });
            }
            return;
          }
          if (item.leaving) {
            item.leaving = false;
            this.mute(item, true);
          }
          if (!item.paused && !item.attempted && item.ratio >= .1 && this.dataset.autoplay === 'true' && !this.reduced.matches && !this.saveData) this.play(item);
        });
        if (this.audio) {
          const item = this.audio;
          const level = Math.max(0,Math.min(1,(item.ratio-.15)/.65));
          if (level === 0) this.mute(item);
          else if (level < .99) {
            if (this.fixedVolume) this.mute(item,true);
            else this.fade(item,level,160);
          } else if (!this.fixedVolume && item.video.volume < .99) this.fade(item,1,160);
        }
      }
      load(item) {
        if (item.video.getAttribute('src')) return;
        const sources = JSON.parse(item.video.dataset.sources || '[]').filter(source => source.mime_type === 'video/mp4' || source.format === 'mp4').sort((a,b) => a.width-b.width);
        const target = Math.min(720,Math.ceil(item.card.clientWidth*Math.min(devicePixelRatio || 1,2)));
        const source = sources.find(candidate => candidate.width >= target) || sources.at(-1);
        if (!source) {
          item.card.querySelector('[data-error]').hidden = false;
          return;
        }
        item.video.src = source.url;
        const track = item.video.querySelector('track[data-src]');
        if (track) track.src = track.dataset.src;
        item.video.load();
      }
      play(item) {
        this.load(item);
        item.attempted = true;
        item.video.play().catch(() => {
          this.mute(item,true);
          this.sync(item);
        });
      }
      sync(item) {
        const playing = !item.video.paused && !item.video.ended;
        const audible = !item.video.muted;
        item.card.toggleAttribute('data-playing',playing);
        item.card.toggleAttribute('data-audible',audible);
        item.card.querySelector('[data-play]').setAttribute('aria-label',playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        const sound = item.card.querySelector('[data-sound]');
        sound.setAttribute('aria-label',audible ? this.dataset.muteLabel : this.dataset.soundLabel);
        sound.setAttribute('aria-pressed',String(audible));
        sound.querySelector('[data-sound-text]').textContent = audible ? this.dataset.muteLabel : this.dataset.soundLabel;
      }
      fade(item, target, duration, after) {
        cancelAnimationFrame(item.fade);
        const from = item.video.volume;
        const start = performance.now();
        const step = now => {
          const progress = Math.min(1,(now-start)/duration);
          item.video.volume = Math.max(0,Math.min(1,from+(target-from)*progress));
          if (progress < 1) item.fade = requestAnimationFrame(step);
          else { item.fade = 0; after?.(); }
        };
        item.fade = requestAnimationFrame(step);
      }
      mute(item, immediate = false, after) {
        if (!item) { after?.(); return; }
        if (this.audio === item) this.audio = null;
        const finish = () => {
          item.video.muted = true;
          item.video.volume = 1;
          this.sync(item);
          after?.();
        };
        cancelAnimationFrame(item.fade);
        item.fade = 0;
        if (immediate || this.fixedVolume || item.video.muted) finish();
        else this.fade(item,0,320,finish);
      }
      stopAll() {
        this.items?.forEach(item => {
          this.mute(item,true);
          item.video.pause();
          item.attempted = false;
        });
      }
      select(item) {
        if (this.audio && this.audio !== item) this.mute(this.audio,true);
        cancelAnimationFrame(item.fade);
        item.fade = 0;
        item.leaving = false;
      }
      click(event) {
        const target = event.target.closest('button,a');
        if (!target) return;
        if (target.hasAttribute('data-prev')) return this.move(-1);
        if (target.hasAttribute('data-next')) return this.move(1);
        if (target.hasAttribute('data-cta') && target.getAttribute('href').startsWith('#')) {
          const hero = document.querySelector('.pmh');
          if (hero) {
            event.preventDefault();
            this.mute(this.audio);
            hero.scrollIntoView({behavior:this.reduced.matches ? 'auto':'smooth',block:'start'});
            const option = hero.querySelector('[data-pmh-var]:not([disabled])');
            option?.focus({preventScroll:true});
          }
          return;
        }
        const item = this.items.find(candidate => candidate.card === target.closest('[data-card]'));
        if (!item) return;
        if (target.hasAttribute('data-play')) {
          if (!item.video.paused) { item.paused = true; this.mute(item,true); item.video.pause(); }
          else { this.select(item); item.paused = false; this.play(item); }
        }
        if (target.hasAttribute('data-sound')) {
          if (!item.video.muted) { this.mute(item,true); return; }
          this.select(item);
          document.dispatchEvent(new CustomEvent('pmvs:sound',{detail:this}));
          this.audio = item;
          item.video.volume = .9;
          this.fixedVolume = Math.abs(item.video.volume-.9) > .01;
          item.video.volume = 1;
          item.video.muted = false;
          item.paused = false;
          this.play(item);
          this.sync(item);
        }
      }
      move(direction) {
        const width = (this.cards[1]?.offsetLeft-this.cards[0]?.offsetLeft) || this.track.clientWidth;
        this.track.scrollBy({left:direction*width,behavior:this.reduced.matches ? 'auto':'smooth'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
